import React from 'react';
import { Img } from 'react-image';
import { gridTemplates } from './task-utility';

const AssessmentQuestion = ({task}) => {
	const gridType = task.taskType.replace(/\s+/g, '');
	const { testSize, testOffset } = gridTemplates[gridType];

	const style = {
		width: `${testSize.width}px`,
		height: `${testSize.height}px`
	};

	if (testOffset) {
		const { top, right } = testOffset;
		style.marginTop = top ? `${top}px` : null;
		style.marginRight = right ? `${right}px` : null;
	}

	const imgProps = {
		className: 'test-image',
		src: task.mediaPath[0],
		alt: gridType,
		style,
		...testSize
	}

	return (
		<div className="assessment-question">
			<Img {...imgProps} loader={
				<img {...imgProps} loading="lazy" />
			} />
		</div>
	);
}

export default AssessmentQuestion;